import React from "react";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,  
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import{thirdPartyOptions} from "pages/commonData";

const initialValues = {
  tpa: "",
  startDate: '',
  endDate: ''
};

const validationSchema = Yup.object({
    tpa: Yup.string().required("Third party Administrator is required"),
});

const thirdPartyOption = [...thirdPartyOptions];

const FileSearch = ({ onSearch,onReset }) => {
  const handleSubmit = (val, action) => {
    const { setSubmitting } = action;
    onSearch();
    setSubmitting(false);
  };

  const handleReset = (props) => {
    const { resetForm } = props;
    resetForm();
    onReset();
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit } = props;
        return (
          <div>
            <h5 className="f-15 text-primary font-weight-700">File Monitoring</h5>
            <Row>
              <Col md={2} sm={3} xs={6}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <Field
                    id="tpa"
                    name="tpa"
                    className="required"
                    type="text"
                    autoComplete="off"
                    component={FormikSelectField}
                    defaultoption="--Select--"
                    options={thirdPartyOption}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2} sm={3} xs={6}>
                <FormGroup>
                  <Label>Date Range</Label>
                  <InputGroup>
                    <Field
                      type="text"
                      id="startDate"
                      name="startDate"
                      autoComplete="off"
                      placeholder="Select Start Date"
                      component={FormikDatePicker}
                      //   onChange={handleStartDate}
                    />
                    <InputGroupText
                    //   onClick={() => handleDateClick("startDate")}
                    >
                      <img src={Calendar} alt="" />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col xs="auto" className="mt-3 pt-3">
                <FormGroup>
                  <Label className="pt-1">-</Label>
                </FormGroup>
              </Col>
              <Col md={2} sm={3} xs={6}>
                <FormGroup>
                  <Label className="text-white">-</Label>
                  <InputGroup>
                    <Field
                      type="text"
                      id="endDate"
                      name="endDate"
                      autoComplete="off"
                      placeholder="Select End Date"
                      component={FormikDatePicker}
                      //   onChange={handleStartDate}
                    />
                    <InputGroupText
                    //   onClick={() => handleDateClick("startDate")}
                    >
                      <img src={Calendar} alt="" />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md="auto" className="pt-4 mt-1">
                <Label>{""}</Label>
                <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  color="primary"
                  className="ms-3"
                >
                  Search
                </Button>
                <Button color="primary" onClick={() => handleReset(props)}>
                  Reset
                </Button>
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default FileSearch;
